export const handleProductQuantityUpdate = (
  productId, quantityChange, legIndex,
  formData, pricingData,
  actions, helpers
) => {
  // Validate leg exists
  const currentLeg = helpers.getLeg(legIndex);
  if (!currentLeg) {
    console.warn(`Leg at index ${legIndex} not found`);
    return formData;
  }

  const selectedProducts = currentLeg.selectedProducts || [];

  // Find the product in pricing data
  let foundProduct = null;
  
  // Search through all rates and their products
  if (pricingData?.rates) {
    for (const rate of pricingData.rates) {
      if (rate.products) {
        foundProduct = rate.products.find(product => product.product_id === productId);
        if (foundProduct) break;
      }
    }
  }

  // If product not found in pricing data, return original formData
  if (!foundProduct) {
    console.warn(`Product with ID ${productId} not found in pricing data`);
    return formData;
  }

  // Check if product already exists in selectedProducts
  const existingIndex = selectedProducts.findIndex(item => item.product_id === productId);
  let updatedSelectedProducts;
  
  if (existingIndex >= 0) {
    // Update existing product quantity
    const currentQuantity = selectedProducts[existingIndex].quantity;
    const newQuantity = Math.max(0, currentQuantity + quantityChange);
    
    // If new quantity is 0, remove the product
    if (newQuantity === 0) {
      updatedSelectedProducts = selectedProducts.filter(item => item.product_id !== productId);
    } else {
      // Update the quantity
      updatedSelectedProducts = [
        ...selectedProducts.slice(0, existingIndex),
        {
          ...selectedProducts[existingIndex],
          quantity: newQuantity
        },
        ...selectedProducts.slice(existingIndex + 1)
      ];
    }
  } else {
    // Only add new product if we're increasing quantity (positive change)
    if (quantityChange > 0) {
      const newProduct = {
        ...foundProduct,
        quantity: quantityChange
      };
      
      updatedSelectedProducts = [...selectedProducts, newProduct];
    } else {
      // If trying to decrease a non-existent product, return original formData
      return formData;
    }
  }

  actions.leg.updateField(legIndex, 'selectedProducts', updatedSelectedProducts);
};

// Format price from cents
export const formatPrice = (priceCents) => {
  return `$${(priceCents / 100).toFixed(2)}`;
};